const SelectAll = () => (
  <svg
    id="Capa_1"
    enable-background="new 0 0 512 512"
    height="24"
    viewBox="0 0 512 512"
    width="24"
    fill="inherit"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <g>
        <g>
          <path d="m230.823 240.82h-190.456c-22.255 0-40.367 18.102-40.367 40.357v190.456c0 22.255 18.112 40.367 40.367 40.367h190.456c22.255 0 40.357-18.112 40.357-40.367v-190.456c0-22.255-18.102-40.357-40.357-40.357zm-10.036 95.663-101.078 101.067c-5.844 5.864-15.347 5.877-21.224 0l-48.082-48.072c-5.854-5.864-5.854-15.37 0-21.234 5.864-5.854 15.37-5.854 21.234 0l37.465 37.465 90.45-90.45c5.864-5.864 15.37-5.864 21.234 0 5.855 5.854 5.855 15.361.001 21.224z" />
        </g>
      </g>
      <g>
        <g>
          <path d="m391.76 159.876v191.897c0 21.855-17.782 39.646-39.636 39.646h-50.924v-110.242c0-38.806-31.571-70.377-70.377-70.377h-110.243v-50.924c0-21.854 17.792-39.636 39.646-39.636h191.897c21.855 0 39.637 17.782 39.637 39.636z" />
        </g>
      </g>
      <g>
        <g>
          <path d="m512 39.646v191.897c0 21.854-17.792 39.636-39.646 39.636h-50.574v-111.303c0-38.405-31.251-69.656-69.656-69.656h-111.304v-50.574c0-21.854 17.782-39.646 39.636-39.646h191.897c21.855 0 39.647 17.792 39.647 39.646z" />
        </g>
      </g>
    </g>
  </svg>
);

export default SelectAll;
